<template>
  <layout-main-inner v-loading="loading">
    <el-dropdown slot="action">
      <el-button
        type="primary"
        style="margin-left: 10px">
        批量操作<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="downloadtemplate(3)">下载模板（商家防伪扣）</el-dropdown-item>
        <el-dropdown-item @click.native="downloadtemplate(4)">下载模板（鉴定意见书）</el-dropdown-item>
        <el-dropdown-item @click.native="addbatchtask(3)">批量上传（商家防伪扣）</el-dropdown-item>
        <el-dropdown-item @click.native="addbatchtask(4)">批量上传（鉴定意见书）</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <layout-card-wrap hasHeaderSlot>
      <template slot="form">
        <!-- <el-input
          v-model="config.vendorName"
          clearable
          placeholder="请输入客户名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input> -->
        <upload-status-select v-model="config.status" />
        <el-button
          style="margin-left: 10px;"
          type="primary"
          @click="handleCurrentChange(1)">刷新</el-button>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="原始文件"
          min-width="240"
          prop="applyName"></el-table-column>
        <el-table-column
          min-width="70"
          label="总数"
          prop="total"></el-table-column>
        <el-table-column
          min-width="70"
          label="成功数"
          prop="successfulCount"></el-table-column>
        <el-table-column
          min-width="70"
          label="失败数"
          prop="failedCount"></el-table-column>
        <el-table-column
          min-width="80"
          label="类型"
          :formatter="(row) =>row.taskType === 1 ? '商家防伪扣' : '鉴定意见书'"
          prop="taskType"></el-table-column>
        <el-table-column
          label="状态"
          min-width="80">
          <template slot-scope="{ row }">
            <el-tag :type="row.status | orderUploadStatusType()">{{ row.status | orderUploadStatusName() }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="150">
          <template slot-scope="{ row }">{{ row.createdTime | dateformat() }}</template>
        </el-table-column>
        <el-table-column
          label="完成时间"
          width="150">
          <template slot-scope="{ row }">{{ row.doneTime | dateformat() }}</template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          min-width="110">
          <template slot-scope="{ row }">
            <el-button
              :disabled="row.status !== 0"
              type="text"
              style="margin-right: 10px"
              @click="cancelcardapplyfile(row)">取消任务</el-button>
            <el-dropdown>
              <el-button type="text">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="downApplyDetail(row.applyFileUrl)">下载原始文件</el-dropdown-item>
                <el-dropdown-item
                  :disabled="row.status === 0"
                  @click.native="downResultDetail(row.resultFileUrl)">下载结果文件</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination-new
        v-model="config"
        :total="total"
        :fetch="fetchList" />
    </layout-card-wrap>

    <upload-new ref="upload" />
  </layout-main-inner>
</template>
<script>
import { downloadBlobFile } from '@/utils/index'
import UploadNew from '@/components/upload-new.vue'
import UploadStatusSelect from './busi/upload-status-select.vue'
import CustomApi from '@/service/custom'
export default {
  name: 'BatchUpload',
  components: { UploadNew, UploadStatusSelect },
  data() {
    return { loading: true, list: [], total: 0, config: { pageNum: 1, pageSize: 10, status: null }}
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    downApplyDetail(url) {
      window.open(url)
      // const arr = url.split('originalfilename')
      // const name = arr.pop().slice(1)
      // downloadFile(url, name, false)
    },
    downResultDetail(url) {
      window.open(url)
      // const arr = url.split('/')
      // const name = arr.pop()
      // console.log(name)
      // downloadFile(url + `?filename=${name}`, name, false)
    },
    cancelcardapplyfile(row) {
      this.$confirm('是否取消任务？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          CustomApi.cancelbatchtask({ id: row.id })
            .then(res => {
              const { result, message } = res.data
              this.loading = false
              if ([0].includes(result)) {
                this.$message.success('取消成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    downloadtemplate(type) {
      this.loading = true
      // 3: 商家防伪扣 4: 鉴定意见书
      const methods = type === 3 ? 'downloadtemplate' : 'downloadcertordertemplate'
      CustomApi[methods]({ })
        .then(res => {
          this.loading = false
          downloadBlobFile(res)
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    addbatchtask(type) {
      this.$refs.upload.upload({ }, (formData) => {
        this.loading = true
        const methods = type === 3 ? 'addbatchtask' : 'addcertorderbatchtask'
        CustomApi[methods](formData)
          .then(res => {
            this.loading = false
            const { result, message } = res.data
            if ([0].includes(result)) {
              this.$message.success('上传成功')
              this.fetchList()
            } else {
              this.$message.error(message)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error(err.message)
          })
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      CustomApi.getbatchtasks({ ...this.config })
        .then(res => {
          this.loading = false
          const { records, total, result, message } = res.data
          if ([0, -13].includes(result)) {
            this.total = total
            this.list = records.map(i => ({ ...i, applyName: i.applyFileUrl.split('originalfilename')[1].slice(1) }))
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
